import { Link } from 'react-router-dom';
import { serviceCards } from '../data/services';
import type { ServiceCard } from '../types';

const ServiceCardItem = ({ s }: { s: ServiceCard }) => {
  return (
    <Link
      to="/leistungen"
      className="group relative flex max-w-[260px] min-w-[200px] flex-1 basis-[200px] flex-col gap-3.5 overflow-hidden rounded-[20px] border border-white/[0.04] bg-ak-dark px-[22px] pt-7 pb-6 no-underline shadow-[inset_0_2px_12px_rgba(0,0,0,0.25)] transition-[transform,background-color,border-color,box-shadow] duration-[250ms] hover:-translate-y-1 hover:border-ak-sky/30 hover:bg-ak-darker hover:shadow-[0_12px_40px_rgba(0,0,0,0.3)]"
    >
      {/* Farbstreifen oben */}
      <div className="absolute inset-x-0 top-0 h-[3px] rounded-t-[20px] bg-ak-sky opacity-0 transition-opacity duration-[250ms] group-hover:opacity-100" />

      <div className="flex h-[52px] w-[52px] items-center justify-center rounded-[14px] bg-ak-yellow/[0.08] transition-colors duration-[250ms] group-hover:bg-ak-sky/[0.13]">
        <i className={`pi ${s.icon} text-[1.6rem] text-ak-yellow transition-colors group-hover:text-ak-sky`}></i>
      </div>

      <div>
        <h3 className="mb-2 text-base font-bold text-white">{s.name}</h3>
        <p className="m-0 text-[13px] leading-[1.55] text-ak-muted">{s.description}</p>
      </div>

      <div className="mt-auto flex items-center gap-1.5 text-[13px] font-medium text-ak-sky">
        Mehr erfahren
        <i className="pi pi-arrow-right text-[11px] transition-transform group-hover:translate-x-1"></i>
      </div>
    </Link>
  );
};

const ServicesOverview = () => {
  return (
    <section id="services-section" className="mx-auto max-w-[1152px] px-8 py-[clamp(48px,8vw,80px)]">
      <div className="mb-12 text-center">
        <h2 className="mb-3 text-[clamp(1.5rem,3vw,2.25rem)] font-bold text-white">
          Meine Leistungen
        </h2>
        <p className="mx-auto max-w-[480px] text-[15px] text-ak-muted">
          Ehrliche Beratung, klare Sprache, faire Preise – ganz ohne Fachchinesisch.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-5">
        {serviceCards.map((s, i) => (
          <ServiceCardItem key={i} s={s} />
        ))}
      </div>
    </section>
  );
};

export default ServicesOverview;
